import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-modernization-readiness-job-history-skeleton',
  templateUrl: './modernization-readiness-job-history-skeleton.component.html',
  styleUrls: ['./modernization-readiness-job-history-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class ModernizationReadinessJobHistorySkeletonComponent {
  readonly rows = [1, 2, 3, 4, 5, 6];
  readonly cols = [1, 2, 3, 4, 5, 6, 7, 8];
}